// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2BUA3","title":"Images45_title__2dXU9","images":"Images45_images__1FAxS"};